import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import store from './store'
import ElementUI from 'element-ui';
import VueRouter from 'vue-router'
import router from './router'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import 'element-ui/lib/theme-chalk/index.css';

import login from "@/components/login"

import wx from 'weixin-js-sdk'

 
Vue.config.ignoredElements = ['wx-open-launch-app'];

Vue.use(ElementUI);
Vue.use(ViewUI);

/** 
 * 图片处理
 * @param {string}} val -  待格式化的值
 * @return {string} - 格式化后的值
 */
Vue.filter('imgfilter', function(val) {
	if (!val) {
		console.log(val)
		return "@/assets/images/logo/logo.png";
	}
	try {
		val = 'https://api.zikkkk.com/uploads/' + val.split('uploads')[1]
		return val;
	} catch (err) {
		val = '/assets/images/logo/logo.png'
		return val;
	}
});

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$wx = wx
Vue.component(login.name,login)
 
new Vue({ 
	store, 
	router,
  render: h => h(App),
}).$mount('#app')
